import { render } from "./PlatformAllItems.vue?vue&type=template&id=f2aa31ca"
import script from "./PlatformAllItems.vue?vue&type=script&lang=js"
export * from "./PlatformAllItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__